import { mergeClassName as e } from "../../utils/data.js";
import { Banner as t } from "../Banner/Banner.js";
import { titleCase as n } from "../../utils/text.js";
import r from "./EnvironmentBanner.module.js";
import { Typography as i } from "../Typography/Typography.js";
import { useId as a, useState as o } from "react";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
import { ArrowRightIcon as u, CaretDownIcon as d, EyeIcon as f } from "@phosphor-icons/react";
//#region lib/components/EnvironmentBanner/EnvironmentBanner.tsx
function p({ environment: p, productionUrl: m, className: h }) {
	let [g, _] = o(!1), v = a();
	if (!p || p === "production") return;
	let y = n(p), b = /* @__PURE__ */ l(s, { children: [
		/* @__PURE__ */ c(f, {
			size: 16,
			weight: "fill"
		}),
		y,
		" mode"
	] });
	return /* @__PURE__ */ l(t, {
		backgroundColor: "info",
		"aria-label": `${y} mode`,
		className: e(r.banner, h),
		children: [
			/* @__PURE__ */ c(i, {
				weight: "medium",
				alignItems: "center",
				className: e(r.label, r.desktopLabel),
				children: b
			}),
			/* @__PURE__ */ l("button", {
				type: "button",
				className: r.toggle,
				"aria-expanded": g,
				"aria-controls": v,
				onClick: () => {
					_(!g);
				},
				children: [/* @__PURE__ */ c(i, {
					weight: "medium",
					alignItems: "center",
					className: r.label,
					children: b
				}), /* @__PURE__ */ c(d, {
					size: 16,
					className: r.caret
				})]
			}),
			/* @__PURE__ */ l("div", {
				id: v,
				className: e(r.details, g && r.expanded),
				children: [/* @__PURE__ */ l(i, {
					paragraph: !0,
					className: r.message,
					children: [
						"You're in the ",
						y,
						" environment. All changes are for testing purposes only and won't affect real-world operations."
					]
				}), /* @__PURE__ */ l("a", {
					className: r.link,
					href: m,
					children: [/* @__PURE__ */ c(i, { children: "Go to Production" }), /* @__PURE__ */ c(u, { size: 16 })]
				})]
			})
		]
	});
}
//#endregion
export { p as EnvironmentBanner };
